import { AutomationActionType } from 'generated-graphql/types';

export const splitAutomationItem = <
  T extends { action: { type: AutomationActionType } }
>(
  automationItem: T[] | undefined
): {
  rulesTasks: T[];
  actionTasks: T[];
} => {
  return (automationItem || []).reduce(
    (acc, task) => {
      if (task.action.type === AutomationActionType.UpdateCandidateStatus) {
        acc.rulesTasks.push(task);
      } else {
        acc.actionTasks.push(task);
      }
      return acc;
    },
    { rulesTasks: [], actionTasks: [] } as { rulesTasks: T[]; actionTasks: T[] }
  );
};
